﻿export interface SelectOption<T> {
    label: string;
    value: T;
}

export type EnumLabelMap = Record<string, string>;

export const enumToSelectOptions = <T>(enumObj: any, labels: EnumLabelMap = {}): SelectOption<T[keyof T]>[] => {
    const entries = Object.entries(enumObj);
    const nonNumericKeyEntries = entries.filter(([key]) => isNaN(Number(key)));
    const hasLabels = Object.keys(labels).length > 0;

    const nonKeys = ['All', 'None', 'Unknown'];
    
    if (!nonNumericKeyEntries.some(([key]) => nonKeys.includes(key))) {
        nonNumericKeyEntries.unshift(['Unknown', -1 as any]);
    }
    
    return nonNumericKeyEntries
        .filter(([key]) => !hasLabels || nonKeys.includes(key) || labels[key] !== undefined)
        .map(([key, value]) => ({
        label: key === 'All' || key === 'None' || key == 'Unknown' ? ' ' : labels[key] ?? key,
        value: value as T[keyof T]
    }));
}

